export const mapMuiFontsToGoogleFonts = (fontFamily) => {
  if (!fontFamily || typeof fontFamily !== 'string' || !fontFamily.trim().length) return [];

  return fontFamily.split(',').map((font) => ({
    font: font.trim(),
    weights: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  }));
};

const muiTheme = {
  palette: {
    background: {
      default: '#3816a3',
    },
    primary: {
      main: '#3816a3',
    },
    grey: {
      main: '#ededed',
    },
    layout: {
      main: '#3816a3',
      contrastText: '#fff',
    },
    progressBar: {
      main: '#f8f8f8',
    },
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '& .MuiTouchRipple-childPulsate': {
            animationIterationCount: '0 !important',
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        ol: {
          paddingInline: '24px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        text: {
          '&.Mui-focusVisible': {
            outline: '2px solid #000',
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          height: '64px',
          minHeight: '64px',
        },
      },
    },
  },
  overrides: {
    ScreenWrapper: {
      maxWidth: '100%',
      topImage: {
        maxWidth: '120px',
      },
    },
    MaterialButtonWrapper: {
      width: '28rem',
    },
    MuiFormLabel: {
      root: {
        fontSize: '1.6rem',
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '1.6rem',
      },
    },
  },
  typography: {
    fontFamily: 'Montserrat',
    htmlFontSize: 10,
    fontSize: 15,
    h1: {
      fontSize: '3.2rem',
      fontWeight: 400,
      color: '#623fd0',
      '&.MuiTypography-h2--big': {
        fontSize: '1.8rem',
      },
    },
    h2: {
      fontSize: '3.2rem',
      fontWeight: 400,
      color: '#623fd0',
      '&.MuiTypography-h2--big': {
        fontSize: '1.8rem',
      },
    },
    body1: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    body2: {
      fontSize: '1.3rem',
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    caption: {
      fontSize: '1.1rem',
      fontWeight: 400,
    },
    button: {
      textTransform: 'none',
      fontSize: '1.5rem',
      fontWeight: 500,
      '&.MuiButton-text': {
        fontWeight: 400,
      },
    },
  },
};

export default muiTheme;
